const NODE = process.env.NODE_ENV;

// 登录
export const login_url = NODE === 'development' ? '开发' : '正式'
// 其他
export const shop_url = NODE === 'development' ? 'http://192.168.0.14:8769' : 'https://api.rangepark.cn'

// export const shop_url = NODE === 'development' ? 'http://api.test.com:8769' : 'http://192.168.0.12:8769'


// WEBPACK FOOTER //
// ./src/global/index.js